export default "__VITE_ASSET__L6JV5lIA__"